import React from "react";
import { Link } from "react-router-dom";
import { useCartStore } from "../../../store/useCartStore";
import { numberWithCommas } from "../../../utils/numberWithCommas";

let open_order = false;
function open_order_list() {
  if (!open_order) {
    open_order = true;
    document.getElementById("order_list_cart").classList.add("d-block");
    document.querySelector(
      "#mini-cart .cart-cta a.order-list i"
    ).style.transform = "rotate(180deg)";
  } else {
    open_order = false;
    document.getElementById("order_list_cart").classList.remove("d-block");
    document.querySelector(
      "#mini-cart .cart-cta a.order-list i"
    ).style.transform = "rotate(0)";
  }
}

function Total_action() {
  const shopping = useCartStore((state) => state.shopping);
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="total-action">
            <div className="total-price">
              <div className="count">
                <span>{shopping.total_items || 0}</span>
                <i className="fab fa-opencart"></i>
              </div>
              <div className="info-price">
                <h4>هزینه پرداختی</h4>
                <p className="price">
                  {numberWithCommas(shopping.total_price)}
                  <span>تومان</span>
                </p>
              </div>
            </div>
            <div className="cart-cta">
              <a href="#!" className="order-list" onClick={open_order_list}>
                لیست سفارش
                <i className="fas fa-angle-down"></i>
              </a>
              <Link to="/cart" className="checkout">
                تکمیل سفارش
                <i className="fas fa-arrow-left"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Total_action;
